module.exports = __webpack_public_path__ + "static/media/BBs_Dinner_Menu_Front.1fd84bc0.png";